import { useEffect, useState } from "react";
import CreateListModal from "./CreateListModal";
import { useHistory } from "react-router-dom";
import axios from "axios";

export default function StudentListDashboard() {

  const API_BASE = "https://api.ilogically.com/api";
  const APP_TOKEN = "87adfacc2dffc65ae172d59a9f0badda";

  const [lists, setLists] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const fetchLists = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${API_BASE}/users/lists`,
        { params: { appToken: APP_TOKEN } }
      );
      setLists(res.data);
    } catch (err) {
      console.error("Fetch lists error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLists();
  }, []);

  const deleteList = async (id) => {
    const confirmDelete = window.confirm("Are you sure?");
    if (!confirmDelete) return;

    await axios.delete(
      `${API_BASE}/users/lists/${id}`,
      { params: { appToken: APP_TOKEN } }
    );

    fetchLists();
  };

  const renameList = async (id, currentName) => {

    const newName = prompt("Enter new name:", currentName);
    if (!newName || newName === currentName) return;

    await axios.patch(
      `${API_BASE}/users/lists/${id}/rename`,
      { name: newName },
      { params: { appToken: APP_TOKEN } }
    );

    fetchLists();
  };

  const duplicateList = async (id) => {

    await axios.post(
      `${API_BASE}/users/lists/${id}/duplicate`,
      {},
      { params: { appToken: APP_TOKEN } }
    );

    fetchLists();
  };

  return (
    <div>

      <h2>User Lists</h2>

      <button onClick={() => setShowModal(true)}>
        + Create New List
      </button>

      {loading && <p>Loading...</p>}

      {!loading && lists.length === 0 && (
        <p>No lists created yet.</p>
      )}

      {!loading && lists.length > 0 && (
        <table border="1" cellPadding="8" width="100%">
          <thead>
            <tr>
              <th>Name</th>
              <th>Members</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {lists.map((list) => (
              <tr key={list.id}>

                <td>
                  <strong>{list.name}</strong>
                  <div style={{ fontSize: 12, color: "#666" }}>
                    {list.description}
                  </div>
                </td>

                <td>{list.membersCount || 0}</td>

                <td>
                  {new Date(list.createdAt).toLocaleDateString()}
                </td>


                <td>
                  <button
                    onClick={() =>
                      history.push(`/apps/dashboard/lists/${list.id}`)
                    }
                  >
                    View
                  </button>

                  <button
                    onClick={() =>
                      renameList(list.id, list.name)
                    }
                    style={{ marginLeft: 6 }}
                  >
                    Rename
                  </button>

                  <button
                    onClick={() => duplicateList(list.id)}
                    style={{ marginLeft: 6 }}
                  >
                    Duplicate
                  </button>

                  <button
                    onClick={() => deleteList(list.id)}
                    style={{ marginLeft: 6, color: "red" }}
                  >
                    Delete
                  </button>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      )}

      {showModal && (
        <CreateListModal
          onClose={() => setShowModal(false)}
          onCreated={fetchLists}
        />
      )}

    </div>
  );
}